/*
 *
 * OperationSummary
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import { connect } from 'react-redux'
import OperationSummary from './OperationSummary'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  summary: state.operations.operation,
  isLoading: state.loading.local_OperationDetails || false,
  operationTerminalId: state.operations?.operationTerminalId || null
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationSummary)
